import { createSlice } from '@reduxjs/toolkit';
import { fetchOpenJobs } from './actions';

const initialState = {
  isLoading: true,
  data: [],
};

const { reducer } = createSlice({
  name: 'jobs',
  initialState,

  reducers: {},

  extraReducers: {
    [fetchOpenJobs.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchOpenJobs.fulfilled]: (state, { payload }) => {
      state.data = payload?.data || [];
      state.isLoading = false;
    },
  },
});

export default reducer;
